import { Modal } from "antd";
import React from "react";
import ReactPlayer from 'react-player';
import "./ViewTutorialModal.less";

export const ViewTutorialModal = ({ visible, onCancel, src, type }) => {
  return (
    <Modal
      centered
      visible
      footer={null}
      // width={1000}
      wrapClassName="viewTutorialPop"
      // eslint-disable-next-line react/jsx-no-duplicate-props
      visible={visible}
      onCancel={onCancel}
    >
      <div className="text-center text-dark px-1 pb-4 w-50 mx-auto">
        View this training to know how to complete this task.
      </div>
      {type === "video" ?
        <ReactPlayer
          playing={true}
          id="tutorialVideo"
          url={
            src
          }
          width={450}
          height={315}
        /> : <img width={450} height={315} src={src} />}

    </Modal>
  );
};
